function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { identityExtractHTMLElement } from '@deephaven/utils';
import { useCallback, useMemo, useState } from 'react';
import useMappedRef from "./useMappedRef.js";
import useResizeObserver from "./useResizeObserver.js";
/**
 * Returns a callback ref that will track the `contentRect` of a given refValue.
 * If the `contentRect` is undefined, it will be set to a new `DOMRect` with
 * zeros for all dimensions.
 * @param map Optional mapping function to extract an HTMLElement from the given
 * refValue
 * @returns Content rect and a ref callback
 */
export function useContentRect() {
  var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identityExtractHTMLElement;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    x = _useState2[0],
    setX = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    y = _useState4[0],
    setY = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    width = _useState6[0],
    setWidth = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    height = _useState8[0],
    setHeight = _useState8[1];
  var contentRect = useMemo(() => new DOMRect(x, y, width, height), [height, width, x, y]);
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    el = _useState0[0],
    setEl = _useState0[1];

  // Callback ref maps the passed in refValue and passes to `setEl`
  var ref = useMappedRef(setEl, map);
  var handleResize = useCallback(_ref => {
    var _firstEntry$contentRe;
    var _ref2 = _slicedToArray(_ref, 1),
      firstEntry = _ref2[0];
    var rect = (_firstEntry$contentRe = firstEntry === null || firstEntry === void 0 ? void 0 : firstEntry.contentRect) !== null && _firstEntry$contentRe !== void 0 ? _firstEntry$contentRe : {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    setX(rect.x);
    setY(rect.y);
    setWidth(rect.width);
    setHeight(rect.height);
  }, []);
  useResizeObserver(el, handleResize);
  return {
    ref,
    contentRect
  };
}
export default useContentRect;
//# sourceMappingURL=useContentRect.js.map